import { useEffect, useState } from "react";

function diff(targetMs) {
  const now = Date.now();
  let d = Math.max(0, targetMs - now);
  const days = Math.floor(d / 86400000);
  d -= days * 86400000;
  const hours = Math.floor(d / 3600000);
  d -= hours * 3600000;
  const minutes = Math.floor(d / 60000);
  d -= minutes * 60000;
  const seconds = Math.floor(d / 1000);
  return { days, hours, minutes, seconds, done: targetMs - now <= 0 };
}

export default function useCountdown(isoString) {
  const targetMs = new Date(isoString).getTime();
  const [t, setT] = useState(() => diff(targetMs));

  useEffect(() => {
    const id = setInterval(() => setT(diff(targetMs)), 1000);
    return () => clearInterval(id);
  }, [targetMs]);

  return t;
}
